module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/_library.js
// module id = 26
// module chunks = 0